module.exports = __webpack_public_path__ + "media/fonts/aileron-light-webfont-d6dd76b3.ttf";